// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2SNmx","buttons":"PendingPaymentAlert_buttons__1milr"};